import { Card } from "@peer-start/ui/reducate";
import { useTranslation } from "react-i18next";
import type { StartingTeacherProgress, StartingTeacherTaskId } from "../data/starting-teacher-route.js";
import { StartingTeacherEmptySticker, StartingTeacherSticker } from "./StartingTeacherSticker.js";

const stickerTasks = ["course", "learn", "practice", "chat"] as const satisfies readonly StartingTeacherTaskId[];

export function StartingTeacherSkillProgress({
  skillId,
  progress,
}: {
  skillId: string;
  progress: StartingTeacherProgress;
}) {
  const { t } = useTranslation();
  const achieved = progress.achievedTasks[skillId];

  return (
      <Card data-control-id="starting-teacher.progress">
        <h2 className="text-sm font-medium">{t("startingTeacher.stampsTitle")}</h2>
        <p className="mt-3 text-sm leading-5 text-secondary-text">{t("startingTeacher.stampsBody")}</p>
        <ul className="mt-3 flex items-start justify-between gap-2">
          {stickerTasks.map((task) => {
            const title =
              task === "course" ? t("startingTeacher.rows.course.title") : t(`startingTeacher.rows.${task}.title`);
            return (
              <li key={task}>
                {achieved?.[task] ? (
                  <StartingTeacherSticker label={t("startingTeacher.stickerLabel", { task: title })} task={task} />
                ) : (
                  <StartingTeacherEmptySticker />
                )}
              </li>
            );
          })}
        </ul>
      </Card>
  );
}
